function interpolateHSL(h1: number, s1: number, l1: number, h2: number, s2: number, l2: number, t: number): string {
  const deltaH = ((h2 - h1 + 540) % 360) - 180;
  const h = (h1 + t * deltaH + 360) % 360;
  const s = s1 + t * (s2 - s1);
  const l = l1 + t * (l2 - l1);
  return `hsl(${h.toFixed(1)}, ${s.toFixed(1)}%, ${l.toFixed(1)}%)`;
}

export function getColorForValue(pattern: number,value: number, max: number): string {
  const ratio = Math.max(0, Math.min(1, (value) / (max || 1)));

  const patterns = [
    [[352.72, 41.18, 50.98], [85.97, 53.6, 50.98]],
    [[350.59, 100, 50], [140.89, 57.73, 61.96]],
  ]

  const [h1, s1, l1] = patterns[pattern][0];
  const [h2, s2, l2] = patterns[pattern][1];

  return interpolateHSL(h1, s1, l1, h2, s2, l2, ratio);
}
